import { deepFlatChildrenOfType as p } from "@project-rouge/rg-core";
const d = (i, o, l, c) => {
  c ?? (c = p(i, ...o));
  const t = {};
  for (const r of o) {
    const f = c.filter((e) => e.type === r);
    f.length > 0 ? t[r] = f.map((e) => l(e)).reduce((e, n) => e + n) : t[r] = 0;
  }
  return t;
};
export {
  d as getMetricFromChildren
};
//# sourceMappingURL=index5.js.map
